// Invite token backend'а — secrets.token_urlsafe(48), ровно 64 символа base64url (app/core/security.py).
// Голый токен узнаётся только по точной длине: иначе серийник или случайное слово ушли бы на экран приглашения.
const BARE_TOKEN = /^[\w-]{64}$/;
const LINK_TOKEN = /^[\w-]+$/;

/**
 * Токен из invite-ссылки `<origin>/invite/<token>`, вставленной вручную, или голый токен; `null` — это не invite.
 * Ссылка принимается с любого домена приложения: её мог выдать другой экземпляр PWA.
 */
export function parseInviteLink(text: string): string | null {
  const value = text.trim();
  if (BARE_TOKEN.test(value)) return value;
  let url: URL;
  try {
    url = new URL(value);
  } catch {
    return null;
  }
  if (url.protocol !== "https:" && url.protocol !== "http:") return null;
  const [token, invite] = url.pathname.replace(/\/+$/, "").split("/").reverse();
  return invite === "invite" && token && LINK_TOKEN.test(token) ? token : null;
}
